import { AfterViewInit, Directive, ElementRef, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { first } from 'rxjs/operators';
import { scrollIntoView } from './scroll-js';

@UntilDestroy()
@Directive({
  standalone: false,
  selector: '[sscAnchorScroll]',
})
export class AnchorScrollDirective implements AfterViewInit {
  @Output() public sscAnchorScrollEndEvent = new EventEmitter();

  constructor(
    private elementRef: ElementRef,
    private activatedRoute: ActivatedRoute,
  ) {}

  public ngAfterViewInit(): void {
    // if the fragment in the URL matches our element we scroll to it
    this.activatedRoute.fragment.pipe(first(), untilDestroyed(this)).subscribe((fragment) => {
      const elementId = this.elementRef.nativeElement.id;
      if (elementId === fragment) {
        scrollIntoView(this.elementRef.nativeElement, {
          behavior: 'smooth',
        }).then(() => {
          this.sscAnchorScrollEndEvent.emit();
        });
      }
    });
  }
}
